<template>
  <div class="has-auth">
    <div class="isbinding">
      <div class="header">
        <div class="header-l">
          <span class="icon"></span>
          <span class="txt">已授权的公众号</span>
        </div>
        <div class="header-r">
          <!-- <mk-button-biz
            v-if="false"
            type="text"
            class="reset-btn"
            @click="authAgain"
          >
            重新授权
          </mk-button-biz> -->
          <mk-button-biz
            type="text"
            @click="showUnbundeleDialog"
          >
            解绑
          </mk-button-biz>
        </div>
      </div>
      <div class="con">
        <div class="img">
          <template v-if="authorizerInfo.headImg">
            <img :src="authorizerInfo.headImg">
          </template>
          <template v-else>
            <img src="@/assets/images/user.png">
          </template>
        </div>
        <div class="con-c">
          <div class="con-center">
            <div class="con-center-item">
              <span class="con-center-item-t">公众号名称：</span>
              {{ authorizerInfo.nickName }}
            </div>
            <div class="con-center-item second">
              <span class="con-center-item-t">类型：</span>
              {{ authorizerInfo.serviceTypeInfo.id === 2 ? '服务号' : '订阅号' }}
            </div>
          </div>
          <div class="content-r">
            <div class="content-r-item">
              <span class="content-r-item-t">主体信息：</span>
              {{ authorizerInfo.principalName }}
            </div>
            <div class="content-r-item second">
              <span class="content-r-item-t">认证状态：</span>
              {{ authorizerInfo.verifyTypeInfo === -1 ? '未认证' : '已认证' }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <synchronize-article :info="authorizerInfo" />
    <!-- 解绑弹窗组件 -->
    <unbundele-dialog
      :visible.sync="isShowUnbundeleDialog"
      :authorizer-app-id="appId"
    ></unbundele-dialog>
  </div>
</template>
<script>
import unbundeleDialog from './unbundele-dialog'
import SynchronizeArticle from './synchronize-article'
const { VUE_APP_PC_B_BASE_URL, VUE_APP_WX_OPEN_BASE_URL } = process.env

export default {
  name: 'Auth',
  components: { unbundeleDialog, SynchronizeArticle },
  mixins: [],
  props: {
    appId: {
      type: String,
      default: ''
    },
    authorizerInfo: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data () {
    return {
      // 弹窗状态
      isShowUnbundeleDialog: false
    }
  },
  methods: {
    // 显示解绑弹窗
    showUnbundeleDialog () {
      this.isShowUnbundeleDialog = true
    },
    // 再次授权
    authAgain () {
      const dustessUrl = encodeURIComponent(window.location.origin + '/#/settings/auth-management')
      const { account } = JSON.parse(window.localStorage.getItem('user'))
      const url = `${VUE_APP_WX_OPEN_BASE_URL}/wxopen/v1/auth/page?companyId=${account}&dustessUrl=${dustessUrl}`
      window.open(url)
      this.$emit('validateDialog', true)
    }
  }
}
</script>
<style lang="scss" scoped>
.has-auth {
  .isbinding {
    width: calc(100% - 40px);
    margin: 0 auto;
    margin-top: 24px;
    border: 1px solid #e8e8e8;

    .header {
      display: flex;
      justify-content: space-between;
      box-shadow: 0 -1px 0 0 rgba(232, 232, 232, 1) inset;
      align-items: center;

      .header-l {
        display: flex;
        margin-left: 16px;

        .icon {
          display: block;
          width: 3px;
          height: 13px;
          background: rgba(0, 156, 255, 1);
          border-radius: 1px;
          margin-right: 4px;
        }

        .txt {
          color: #595959;
          font-size: 13px;
          font-weight: 500;
        }
      }

      .header-r {
        margin-right: 25px;

        .reset-btn {
          margin-right: 20px;
        }
      }
    }

    .con {
      width: calc(100% - 40px);
      margin: 0 auto;
      padding: 20px 0;
      display: flex;
      align-items: center;

      .img {
        width: 60px;
        height: 60px;
        border-radius: 4px;
        overflow: hidden;
        margin-right: 30px;
        flex-shrink: 0;

        img {
          display: block;
          width: 60px;
          height: 60px;
        }
      }

      .con-c {
        display: flex;
        width: 100%;

        .con-center,
        .content-r {
          flex: 1;
          color: #262626;
          font-size: 13px;

          .second {
            margin-top: 10px;
          }
        }

        .con-center-item-t,
        .content-r-item-t {
          color: #595959;
        }
      }
    }
  }

  .unbundele {
    font-size: 16px;
    color: #009cff;
    position: absolute;
    right: 30px;
    bottom: 10px;
    cursor: pointer;

    .authAgain {
      padding-right: 30px;
    }
  }
}
</style>
